import React, { PureComponent } from 'react';
import styled from 'styled-components';
import printJS from 'print-js';
import imagesLoaded from 'imagesloaded';
import Modal from '../Modal';

const Button = styled.button`
  color: #7d7773;
  border: 1px solid #7d7773;
  width: 100%;
  text-align: center;
  height: 36px;
  margin: 8px auto;
  background-color: transparent;
  display: inline-block;
  font-family: HelveticaNeueLTPro-Roman;
  font-size: 13px;
  line-height: 36px;
  padding: 0 20px;
  cursor: pointer;
  text-transform: uppercase;
  outline: 0;
  :active {
    border: 1px solid #5bb9ef;
    color: #5bb9ef;
  }
  :focus {
    border: 1px solid #5bb9ef;
    color: #5bb9ef;
  }
  :hover {
    border: 1px solid #5bb9ef;
    color: #5bb9ef;
  }
`;

const BtnGroup = styled.div`
  display: grid;
  margin-top: 20px;
`;

const PDF = styled.div`
  display: none;
  width: 100%;
  padding: 0;
  margin: 0;
  height: 1000px;
`;
const PDFWapper = styled.div`
  font-family: Arial;
  position: relative;
  width: 720px;
  height: 960px;
  padding: 0;
  margin: 0;
`;
const PDFHeader = styled.div`
  font-family: Arial;
  text-transform: none;
  margin-top: 2px;
  padding-left: 10px;
`;
const PDFImage = styled.div`
  width: 100%;
  height: 800px;
  padding: 5px 10px 30px 10px;
  box-sizing: border-box;
  text-align: center;
`;
const PDFFooter = styled.div`
  width: 85px;
  text-align: right;
  position: absolute;
  bottom: 10px;
  right: 10px;
`;
export default class Share extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      modalData: {},
      snapLink: '',
    };
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal = () => {
    this.setState({ modalOpen: false });
    this.props.setShareState('none');
  };

  openModal(type) {
    const { shareOrder } = this.props;
    const options = [
      { label: 'First name', value: 'firstname' },
      { label: 'Last name', value: 'lastname' },
      { label: 'Email', value: 'email' },
    ];
    const modalData = { type, options };

    if (type !== 'facebook' && type !== 'twitter') {
      this.setState({ modalOpen: true, modalData });
    } else {
      shareOrder(type, {
        firstname: '',
        lastname: '',
        email: '',
        message: '',
      });
    }
  }

  shareOrder = async user => {
    const { shareOrder } = this.props;
    const { modalData } = this.state;
    const type = modalData.type;

    const res = await shareOrder(type, user);
    if (type === 'print' && res) {
      this.setState({ snapLink: res });
    }
  };
  componentDidUpdate(prevProps, prevState) {
    if (prevState.snapLink !== this.state.snapLink) {
      const elm = document.getElementById('mainImg');
      imagesLoaded(elm, () => {
        printJS({
          printable: 'pdfDiv',
          type: 'html',
          targetStyles: ['*'],
        });
      });
    }
  }
  render() {
    const { modalOpen, modalData, snapLink } = this.state;
    const { shareState, setShareState } = this.props;
    return (
      <BtnGroup>
        <Button primary onClick={e => this.openModal('print')}>
          Print
        </Button>
        <Button onClick={e => this.openModal('email')}> Email </Button>
        <Modal
          open={modalOpen}
          closeModal={this.closeModal}
          data={modalData}
          actionFn={this.shareOrder.bind(this)}
          shareState={shareState}
          setShareState={setShareState}
        />

        <PDF>
          <PDFWapper id="pdfDiv">
            <PDFHeader>
              <div
                style={{
                  fontFamily: 'Arial',
                  fontWeight: 'normal',
                  fontSize: '25px',
                }}
              >
                SILQ Customizer
              </div>
              <p
                style={{
                  fontFamily: 'Arial',
                  fontSize: '10px',
                  fontWeight: 'normal',
                  marginTop: '20px',
                }}
              >
                silqcustomizer.steelcase.com
              </p>
            </PDFHeader>
            <PDFImage>
              <img
                id="mainImg"
                style={{
                  width: '600px',
                  height: '800px',
                  padding: 0,
                }}
                src={snapLink}
              />
            </PDFImage>
            <PDFFooter>
              <img
                style={{
                  width: '85px',
                }}
                src="https://upload.wikimedia.org/wikipedia/en/0/0e/Steelcase_logo.svg"
              />
            </PDFFooter>
          </PDFWapper>
        </PDF>
      </BtnGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accords/Share.js